import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { NumericFormat } from 'react-number-format';
import { SearchSKUgaleriaAction, GaleriaLikeAction, GaleriaCheckboxVitrineAction } from '../../../actions/EspacoTecaActions';
import { Input, Card, Icon, Button, Image, Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';


const CarouselContainer = styled.div`
  display: flex;
  gap: 10px;
  overflow-x: auto;       /* permite scroll horizontal */
  padding-bottom: 5px;    /* evita que a barra de rolagem sobreponha itens */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* para swipe em mobile */
`;

const CarouselItem = styled.div`
  flex: 0 0 auto;         /* garante que cada item não encolha */
  width: 150px;
  height: 150px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
`;

const CarouselMedia = styled.img`
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
`;

const CarouselVideo = styled.video`
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
`;;

function Galeria({ navigateToGaleria, ...props }) {
    const { SearchSKUgaleriaAction, isSearchingGaleria, dadosBanco = [], GaleriaLikeAction, userid, GaleriaCheckboxVitrineAction, urlsVitrine, lastSKUsearch } = props;

    const [searchSKU, setSearchSKU] = useState('');
    const [SKUMessage, setSKUMessage] = useState('');
    const [SKUName, setSKUName] = useState('');
    const [SKUDetalhes, setSKUDetalhes] = useState('');
    const [errorSaving, setErrorSaving] = useState([]);
    const [selectedNames, setSelectedNames] = useState([]);
    const [selectedNamesTemp, setSelectedNamesTemp] = useState([]);
    const [liked, setLiked] = useState([]);
    const [uploads, setUploads] = useState([]);
    const [likedMidias, setLikedMidias] = useState([]);
    const [showVideos, setShowVideos] = useState(false);
    const [showImages, setShowImages] = useState(false);
    const [likedShowVideos, setLikedShowVideos] = useState(false);
    const [likedShowImages, setLikedShowImages] = useState(false);


    // Agrupar dados por idgaleria

    const groupUploads = (dados) => {
        const grouped = {};
        dados.forEach((item) => {
            if (!grouped[item.idgaleria]) {
                const dateObj = new Date(item.dtupload?.pin ? item.dtupload.pin : item.dtupload);
                grouped[item.idgaleria] = {
                    id: item.idgaleria,
                    nome: item.user,
                    dateObj,
                    nomeprod: item.nomeprod,
                    texto: item.texto,
                    midias: [],
                    observation: item.observation,
                    curtida: item.curtida,
                    isecommerce: item.isecommerce,
                    isfabricante: item.isfabricante,
                    dtaprovado: item.dtaprovacao
                };
            }
            if (item.url) {
                grouped[item.idgaleria].midias.push({
                    url: item.url,
                    idmidia: item.idmidia,
                    sku: searchSKU,
                    nomeprod: item.nomeprod,
                    dtaprovacao: item.dtaprovacao
                });
            }
        });
        return Object.values(grouped);
    };

    // Sempre que os dados do banco mudarem, atualizar os uploads
    useEffect(() => {
        if (searchSKU != '' && searchSKU == dadosBanco?.[0]?.sku) {
            if (dadosBanco.length > 0) {
                // console.log(dadosBanco)
                const uploadsGrouped = groupUploads(dadosBanco);
                setUploads(uploadsGrouped);
                const initialLiked = [];
                const initialLikedMidias = [];
                dadosBanco.forEach((item) => {
                    if (item.curtida === 1 && item.usercurtida == userid) {
                        const upload = dadosBanco.filter(d => d.idgaleria === item.idgaleria);
                        const midiaIndex = upload.findIndex(d => d.idmidia === item.idmidia);

                        if (midiaIndex !== -1) {
                            const key = `${item.idgaleria}-${midiaIndex}`;
                            initialLiked.push(key);
                            initialLikedMidias.push({
                                idgaleria: item.idgaleria,
                                idmidia: item.idmidia,
                                url: item.url,
                                sku: item.sku,
                                nomeprod: item.nomeprod,
                                dtaprovacao: item.dtaprovacao
                            });
                        }
                    }
                });

                setLiked(initialLiked);
                setLikedMidias(initialLikedMidias);
            }
        }
        else if (dadosBanco?.[0]?.sku !== lastSKUsearch && searchSKU == '') {
            setSearchSKU(lastSKUsearch)
            handleSearchSKU(lastSKUsearch)
        }


    }, [dadosBanco, userid]);

    const handleSearchSKU = (sku) => {
        const finalSku = sku || searchSKU;
        if (!finalSku) return;
        SearchSKUgaleriaAction(finalSku).then((dados) => {
            if (!dados || dados.length === 0) return;
            setSKUName(dados[0].nomeprod || '');
            setSKUMessage(dados[0].message || '');
            setSKUDetalhes(dados[0].texto || '');
        });
    };

    const handleUnlikeFromLikedBlock = (midia) => {
        // remove do bloco de curtidas
        setLikedMidias(prev => prev.filter(m => m.idmidia !== midia.idmidia));

        // remove do bloco original
        setLiked(prev => prev.filter(k => !k.startsWith(`${midia.idgaleria}-`)));

        // atualiza backend
        GaleriaLikeAction({
            midiaid: midia.idmidia,
            userid,
            curtida: 0
        });
    };

    const handleLike = (uploadId, fotoIndex, midiaid, url, sku) => {
        const key = `${uploadId}-${fotoIndex}`;
        const isLiked = liked.includes(key);

        setLiked((prev) =>
            isLiked ? prev.filter((k) => k !== key) : [...prev, key]
        );

        // Atualiza "Minhas Curtidas"
        setLikedMidias((prev) =>
            isLiked
                ? prev.filter((m) => m.idmidia !== midiaid) // remove se descurtir
                : [...prev, { idgaleria: uploadId, idmidia: midiaid, url, sku: sku }] // adiciona se curtir
        );

        let data = {
            midiaid,
            userid,
            curtida: isLiked ? 0 : 1
        };

        GaleriaLikeAction(data);
    };
    const handleCheckVitrine = (url, sku, nomeprod) => {
        // console.timeLog(sku)
        GaleriaCheckboxVitrineAction({ sku, url, nomeprod })
    }
    // Criar filtro com todos os nomes distintos (users)
    const filterOptions = [
        ...new Set(
            uploads
                .filter(u => u.isecommerce !== 1 && u.isfabricante !== 1) // ignora blocos fixos
                .map(u => u.nome)
        )
    ].map((nome) => ({
        key: nome,
        text: nome,
        value: nome,
    }));

    // Aplicar filtro (se houver nomes selecionados)
    // === Blocos fixos (SEM filtro) ===
    const ecommerceUploads = uploads.filter(u => u.isecommerce === 1 && u.dtaprovacao !== null);
    const fabricanteUploads = uploads.filter(u => u.isfabricante === 1 && u.dtaprovacao !== null);

    console.log(uploads)
    console.log(ecommerceUploads)
    // === Blocos filtrados (somente normais) ===
    const filteredUploads =
        uploads
            .filter(u => u.isecommerce !== 1 && u.isfabricante !== 1) // só os normais
            .filter(u => selectedNames.length === 0 || selectedNames.includes(u.nome))
            .map(u => {
                let midiasFiltered = u.midias.filter(m => m.dtaprovacao);
                console.log(u.midias)
                if (showVideos && !showImages) {
                    midiasFiltered = midiasFiltered.filter(m => m.url.endsWith('.mp4'));
                } else if (!showVideos && showImages) {
                    midiasFiltered = midiasFiltered.filter(m => !m.url.endsWith('.mp4'));
                }
                return { ...u, midias: midiasFiltered };
            })
            .filter(u => u.midias.length > 0);

    const sortedUploads = [...filteredUploads].sort((a, b) => b.dateObj - a.dateObj);

    console.log(sortedUploads)
    return (
        <>
            {/* Bloco de busca */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '1rem',
                    marginTop: '1rem',
                }}
            >
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <NumericFormat
                        placeholder="SKU"
                        name="sku"
                        customInput={Input}
                        control="input"
                        allowLeadingZeros={true}
                        value={searchSKU}
                        // onBlur={handleSearchSKU}
                        onBlur={() => handleSearchSKU()} // agora não precisa passar string vazia
                        onChange={(e) => setSearchSKU(e.target.value)}
                        error={errorSaving.some(a => a.campo === 'sku' && (!a.sku || a.sku === ''))}
                        loading={isSearchingGaleria}
                    />
                    <p style={{ color: 'grey' }}>
                        {SKUName}
                    </p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Button
                        color='green'
                        onClick={() => navigateToGaleria()}
                    >Montar Vitrine</Button>
                    <p style={{ color: 'gray', fontStyle: 'italic' }}>{urlsVitrine.length} imagens selecionadas</p>
                </div>

            </div>
            {SKUMessage && <p style={{ color: 'red' }}>{SKUMessage}</p>}

            {/* Informações do produto */}
            {SKUDetalhes &&
                <Card fluid>
                    <Card.Content>
                        <Card.Header>Informações do Produto</Card.Header>
                        <Card.Meta>{SKUDetalhes}</Card.Meta>
                    </Card.Content>
                </Card>
            }


            {/* Galeria de uploads */}
            <div style={{ marginTop: '2rem' }}>
                {/* Topo da galeria */}
                {SKUDetalhes && (
                    <Card fluid style={{ marginBottom: '2rem' }}>
                        <Card.Content>
                            {/* Cabeçalho com título e checkboxes */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <Card.Header style={{ fontSize: '19px', fontWeight: 'bold' }}>Minhas Curtidas</Card.Header>

                                {/* Checkboxes */}
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={likedShowVideos}
                                            onChange={() => setLikedShowVideos(prev => !prev)}
                                        /> Vídeo
                                    </label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={likedShowImages}
                                            onChange={() => setLikedShowImages(prev => !prev)}
                                        /> Imagem
                                    </label>
                                </div>
                            </div>

                            {likedMidias.length === 0 ? (
                                <p style={{ color: 'grey' }}>Nenhuma curtida ainda</p>
                            ) : (
                                <CarouselContainer>
                                    {likedMidias
                                        .filter(midia => {
                                            if (likedShowVideos && !likedShowImages) return midia.url.endsWith('.mp4');
                                            if (!likedShowVideos && likedShowImages) return !midia.url.endsWith('.mp4');
                                            return true; // caso ambos ou nenhum selecionado, mostra todos
                                        })
                                        .map((midia) => {
                                            const isLiked = true; // todas aqui já estão curtidas pelo usuário
                                            return (
                                                <CarouselItem key={midia.idmidia}
                                                    onClick={() => window.open(midia.url, '_blank')}>
                                                    {midia.url.endsWith('.mp4') ? (
                                                        <CarouselVideo controls>
                                                            <source src={midia.url} type={midia.tipoArquivo || "video/mp4"} />
                                                            Seu navegador não suporta vídeo.
                                                        </CarouselVideo>
                                                    ) : (
                                                        <CarouselMedia src={midia.url} alt={midia.nomeProduto} />
                                                    )}
                                                    <input
                                                        type="checkbox"
                                                        style={{
                                                            position: "absolute",
                                                            top: "5px",
                                                            left: "5px",
                                                            minWidth: "0",
                                                            padding: "6px",
                                                            transform: "scale(1.5)", // aumenta o tamanho
                                                            zIndex: 10,
                                                            margin: "5px",
                                                            cursor: "pointer",
                                                        }}
                                                        checked={urlsVitrine.some((i) => i.url === midia.url,)}
                                                        onChange={(e) => {
                                                            handleCheckVitrine(midia.url, midia.sku, midia.nomeprod);
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    />
                                                    <Button
                                                        icon
                                                        color='red'
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleUnlikeFromLikedBlock(midia);
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: '5px',
                                                            right: '5px',
                                                            minWidth: 0,
                                                            padding: '6px',
                                                            borderRadius: '50%',
                                                            zIndex: 10,
                                                        }}
                                                    >
                                                        <Icon name="heart" />
                                                    </Button>
                                                </CarouselItem>
                                            );
                                        })}
                                </CarouselContainer>
                            )}
                        </Card.Content>
                    </Card>
                )}

                {/* === NOVO BLOCO FIXO: E-COMMERCE === */}
                {SKUDetalhes && (
                    <Card fluid style={{ marginBottom: '2rem' }}>
                        <Card.Content>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '1rem',
                                }}
                            >
                                <Card.Header style={{ fontSize: '19px', fontWeight: 'bold' }}>
                                    E-commerce
                                </Card.Header>
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={showVideos}
                                            onChange={() => setShowVideos(!showVideos)}
                                        /> Vídeo
                                    </label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={showImages}
                                            onChange={() => setShowImages(!showImages)}
                                        /> Imagem
                                    </label>
                                </div>
                            </div>

                            {ecommerceUploads.length === 0 ? (
                                <p style={{ color: 'grey' }}>Nenhuma imagem carregada ainda</p>
                            ) : (
                                <CarouselContainer>
                                    {ecommerceUploads.map((upload, uploadIndex) =>
                                        upload.midias
                                            .filter((midia) => {
                                                console.log(ecommerceUploads)
                                                if (midia.dtaprovacao == null) return midia.url.endsWith('.mp4')
                                                if (showVideos && !showImages) return midia.url.endsWith('.mp4');
                                                if (!showVideos && showImages) return !midia.url.endsWith('.mp4');
                                                return true;
                                            })
                                            .map((midia, index) => {
                                                const key = `${upload.id}-${index}`;
                                                return (
                                                    <CarouselItem
                                                        key={key}
                                                        onClick={() => window.open(midia.url, '_blank')}
                                                    >
                                                        {midia.url.endsWith('.mp4') ? (
                                                            <CarouselVideo controls src={midia.url} />
                                                        ) : (
                                                            <CarouselMedia src={midia.url} alt="" />
                                                        )}
                                                        <input
                                                            type="checkbox"
                                                            style={{
                                                                position: "absolute",
                                                                top: "5px",
                                                                left: "5px",
                                                                minWidth: "0",
                                                                padding: "6px",
                                                                transform: "scale(1.5)", // aumenta o tamanho
                                                                zIndex: 10,
                                                                margin: "5px",
                                                                cursor: "pointer",
                                                            }}
                                                            checked={urlsVitrine.some((i) => i.url === midia.url,)}
                                                            onChange={(e) => {
                                                                handleCheckVitrine(midia.url, midia.sku, midia.nomeprod);
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        />
                                                        <Button
                                                            icon
                                                            color={liked.includes(key) ? 'red' : 'grey'}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleLike(upload.id, index, midia.idmidia, midia.url, upload.sku);
                                                            }}
                                                            style={{
                                                                position: 'absolute',
                                                                bottom: '5px',
                                                                right: '5px',
                                                                minWidth: '0',
                                                                padding: '6px',
                                                                borderRadius: '50%',
                                                                zIndex: 10,
                                                            }}
                                                        >
                                                            <Icon name="heart" />
                                                        </Button>
                                                    </CarouselItem>
                                                );
                                            })
                                    )}
                                </CarouselContainer>
                            )}
                        </Card.Content>
                    </Card>
                )}

                {/* === NOVO BLOCO FIXO: FABRICANTE === */}
                {SKUDetalhes && (
                    <Card fluid style={{ marginBottom: '2rem' }}>
                        <Card.Content>
                            {/* Cabeçalho com título e checkboxes */}
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '1rem',
                                }}
                            >
                                <Card.Header style={{ fontSize: '19px', fontWeight: 'bold' }}>
                                    Fabricante
                                </Card.Header>

                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={fabricanteUploads[0]?.showVideos || false}
                                            onChange={() => {
                                                setUploads((prev) =>
                                                    prev.map((u) =>
                                                        u.isfabricante === 1
                                                            ? { ...u, showVideos: !u.showVideos }
                                                            : u
                                                    )
                                                );
                                            }}
                                        />{" "}
                                        Vídeo
                                    </label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={fabricanteUploads[0]?.showImages || false}
                                            onChange={() => {
                                                setUploads((prev) =>
                                                    prev.map((u) =>
                                                        u.isfabricante === 1
                                                            ? { ...u, showImages: !u.showImages }
                                                            : u
                                                    )
                                                );
                                            }}
                                        />{" "}
                                        Imagem
                                    </label>
                                </div>
                            </div>

                            {fabricanteUploads.length === 0 ? (
                                <p style={{ color: "grey" }}>Nenhuma imagem carregada ainda</p>
                            ) : (
                                fabricanteUploads.map((upload) => (
                                    <CarouselContainer key={upload.id}>
                                        {upload.midias
                                            .filter((midia) => {
                                                if (upload.showVideos && !upload.showImages)
                                                    return midia.url.endsWith(".mp4");
                                                if (!upload.showVideos && upload.showImages)
                                                    return !midia.url.endsWith(".mp4");
                                                return true;
                                            })
                                            .map((midia, index) => {
                                                const key = `${upload.id}-${index}`;
                                                return (
                                                    <CarouselItem
                                                        key={key}
                                                        onClick={() => window.open(midia.url, "_blank")}
                                                    >
                                                        {midia.url.endsWith(".mp4") ? (
                                                            <CarouselVideo controls src={midia.url} />
                                                        ) : (
                                                            <CarouselMedia src={midia.url} alt="" />
                                                        )}
                                                        <input
                                                            type="checkbox"
                                                            style={{
                                                                position: "absolute",
                                                                top: "5px",
                                                                left: "5px",
                                                                minWidth: "0",
                                                                padding: "6px",
                                                                transform: "scale(1.5)", // aumenta o tamanho
                                                                zIndex: 10,
                                                                margin: "5px",
                                                                cursor: "pointer",
                                                            }}
                                                            checked={urlsVitrine.some((i) => i.url === midia.url,)}
                                                            onChange={(e) => {
                                                                handleCheckVitrine(midia.url, midia.sku, midia.nomeprod);
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        />
                                                        <Button
                                                            icon
                                                            color={liked.includes(key) ? 'red' : 'grey'}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleLike(upload.id, index, midia.idmidia, midia.url, upload.sku);
                                                            }}
                                                            style={{
                                                                position: 'absolute',
                                                                bottom: '5px',
                                                                right: '5px',
                                                                minWidth: '0',
                                                                padding: '6px',
                                                                borderRadius: '50%',
                                                                zIndex: 10,
                                                            }}
                                                        >
                                                            <Icon name="heart" />
                                                        </Button>
                                                    </CarouselItem>
                                                );
                                            })}
                                    </CarouselContainer>
                                ))
                            )}
                        </Card.Content>
                    </Card>
                )}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginBottom: '1rem',
                        gap: '0.5rem',
                        alignItems: 'center',
                    }}
                >
                    <Dropdown
                        placeholder="Selecione nomes"
                        multiple
                        selection
                        options={filterOptions}
                        value={selectedNamesTemp}
                        onChange={(e, { value }) => setSelectedNamesTemp(value)}
                        style={{ minWidth: '150px' }}
                    />

                    {/* Botão para aplicar filtro */}
                    <Button
                        color="blue"
                        onClick={() => setSelectedNames(selectedNamesTemp)}
                    >
                        Aplicar
                    </Button>
                </div>
                {/* Lista de blocos */}
                {sortedUploads.map(upload => (
                    <Card fluid key={upload.id} style={{ marginBottom: '1rem' }}>
                        <Card.Content>
                            {/* Cabeçalho com nome, data e checkboxes */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <Card.Header>
                                        {upload.nome}{" "}
                                        <small style={{ color: 'gray' }}>
                                            ( Enviado em {upload.dateObj.toLocaleString("pt-BR", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit"
                                            })} )
                                        </small>
                                    </Card.Header>
                                </div>

                                {/* Checkboxes de filtro de mídia */}
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={upload.showVideos || false}
                                            onChange={() => {
                                                setUploads(prev => prev.map(u =>
                                                    u.id === upload.id ? { ...u, showVideos: !u.showVideos } : u
                                                ));
                                            }}
                                        /> Vídeo
                                    </label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={upload.showImages || false}
                                            onChange={() => {
                                                setUploads(prev => prev.map(u =>
                                                    u.id === upload.id ? { ...u, showImages: !u.showImages } : u
                                                ));
                                            }}
                                        /> Imagem
                                    </label>
                                </div>
                            </div>

                            <Card.Description style={{ marginBottom: '1rem' }}>
                                Observação: {upload.observation || "Esta vitrine não possui observações."}
                            </Card.Description>

                            {/* Carrossel filtrando mídias conforme os checkboxes */}
                            <CarouselContainer>
                                {upload.midias
                                    .filter(midia => {
                                        if (upload.showVideos && !upload.showImages) return midia.url.endsWith('.mp4');
                                        if (!upload.showVideos && upload.showImages) return !midia.url.endsWith('.mp4');
                                        return true; // caso ambos ou nenhum selecionado, mostra todos
                                    })
                                    .map((midia, index) => {
                                        const key = `${upload.id}-${index}`;
                                        return (
                                            <CarouselItem
                                                key={key}
                                                onClick={() => window.open(midia.url, '_blank')}
                                            >
                                                {midia.url.endsWith('.mp4') ? (
                                                    <CarouselVideo controls src={midia.url} />
                                                ) : (
                                                    <CarouselMedia src={midia.url} alt="" />
                                                )}
                                                <input
                                                    type="checkbox"
                                                    style={{
                                                        position: "absolute",
                                                        top: "5px",
                                                        left: "5px",
                                                        minWidth: "0",
                                                        padding: "6px",
                                                        transform: "scale(1.5)", // aumenta o tamanho
                                                        zIndex: 10,
                                                        margin: "5px",
                                                        cursor: "pointer",
                                                    }}
                                                    checked={urlsVitrine.some((i) => i.url === midia.url,)}
                                                    onChange={(e) => {
                                                        handleCheckVitrine(midia.url, midia.sku, midia.nomeprod);
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                    }}
                                                />
                                                <Button
                                                    icon
                                                    color={liked.includes(key) ? 'red' : 'grey'}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleLike(upload.id, index, midia.idmidia, midia.url, upload.sku);
                                                    }}
                                                    style={{
                                                        position: 'absolute',
                                                        bottom: '5px',
                                                        right: '5px',
                                                        minWidth: '0',
                                                        padding: '6px',
                                                        borderRadius: '50%',
                                                        zIndex: 10,
                                                    }}
                                                >
                                                    <Icon name="heart" />
                                                </Button>
                                            </CarouselItem>
                                        );
                                    })}
                            </CarouselContainer>
                        </Card.Content>
                    </Card>
                ))}

            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    isSearchingGaleria: state.EspacoTecaReducer.isSearchingGaleria,
    dadosBanco: state.EspacoTecaReducer.dadosGaleria,
    userid: state.LoginReducer.userid,
    urlsVitrine: state.EspacoTecaReducer.urlsVitrine,
    lastSKUsearch: state.EspacoTecaReducer.lastSKUsearch
});

export default withRouter(
    connect(mapStateToProps, { SearchSKUgaleriaAction, GaleriaLikeAction, GaleriaCheckboxVitrineAction })(Galeria)
);
